<form [formGroup]="loanProductCurrencyForm">
  <div class="layout-row-wrap gap-2px responsive-column">
    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Currency' | translate }}</mat-label>
      <mat-select
        formControlName="currencyCode"
        matTooltip="{{ 'tooltips.The currency in which the loan will be disbursed' | translate }}"
        required
      >
        @for (currency of currencyData; track currency) {
          <mat-option [value]="currency.code">
            {{ currency.name }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Currency' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Decimal Places' | translate }}</mat-label>
      <input
        type="number"
        matTooltip="{{ 'tooltips.Number of decimal places to be used to track and report' | translate }}"
        matInput
        formControlName="digitsAfterDecimal"
        required
      />
      <mat-error>
        {{ 'labels.inputs.Decimal Places' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Currency in multiples of' | translate }}</mat-label>
      <input
        type="number"
        matInput
        matTooltip="{{ 'tooltips.Enter multiples of currency value' | translate }}"
        formControlName="inMultiplesOf"
      />
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Installment in multiples of' | translate }}</mat-label>
      <input type="number" matInput formControlName="installmentAmountInMultiplesOf" />
    </mat-form-field>
  </div>

  <div class="layout-row align-center gap-2percent margin-t responsive-column">
    <button mat-raised-button matStepperPrevious>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext>
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
